// export const BASE_URL = 'https://hashedapp-api.laxstatclock.com/'; //prod
// export const BASE_URL = "http://localhost:4000/";
export const BASE_URL = "https://flathmann-backend.onrender.com";
// export const BASE_URL = 'http://192.168.223.37:3000/';
